import { Directive, HostListener, Input } from '@angular/core'
import { Store } from '@ngrx/store'
import { GtmEvents } from '@adex/shared/models/gtm-events'
import { sendGTMEvent } from '@adex/store/actions'


@Directive({
  selector: '[adexGtm]'
})
export class GtmDirective {

  @Input() private gtmClick: GtmEvents

  constructor(private readonly store: Store) {
  }

  @HostListener('click')
  private onClick() {
    if (!this.gtmClick) return
    this.store.dispatch(sendGTMEvent({ event: { ...this.gtmClick } }))
  }

}
